import { createRouter, createWebHistory } from "vue-router";
import License from "@/pages/license.vue";

export const router = createRouter({
    routes: [
        {
            path: "/license",
            name: "license",
            component: License,
        },
    ],
    history: createWebHistory(),
});
